import React from "react";
import "./page.css";

const Publications = () => {
    const title = (
        <>
            Publications
        </>  
    );

    // If needed change the `url` to link or something... 
    // In this case yo would need to change in the mapping system (here `publication.url`, replace `url` to the apporiate one). 
    const publications = {
        "2024": [
            { title: "In progress", url: "#" }, 
        ]
    };

    const sortedYears = Object.keys(publications).sort((a, b) => b - a);

    // const paraText = `Enter the text here.`;

    return (
        <div className="page">
            <div className="page-title">
                <h1>{title}</h1>
            </div>
        <br />
            <br />
            <br />

            {/* <div className="page-item">
                <p>{paraText}</p>
            </div>
            <br />
            <br /> */}

            {sortedYears.map((year, index) => (
                <div key={index}>
                    <div className="page-category">
                        <h2>{year}</h2>
                        <ul className="page-list">
                            {publications[year].map((publication, subIndex) => (
                                <li key={subIndex} className="page-item">
                                    <h3>
                                        <a href={publication.url} className="page-link" target="_blank" rel="noopener noreferrer">
                                            {publication.title}
                                        </a>
                                    </h3>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <br />
                </div>
            ))}
        </div>
    );
};

export default Publications;
